const SitioOportunity = {
    NI: {},
    CR: {
        AutoCorreduria: 1,
        AutoEmision: 2,
        VidaAutoExpedible: 3
    },
    HN: {}
}

export {
    SitioOportunity
}